export default __webpack_public_path__ + "static/media/yeezyh2.81ac7b1d.jpg";